/**
 * Dashboard — shared helpers.
 * Extracted from `pages/Dashboard.js` so the container is just state
 * + top-level layout.
 */
export const WEEKDAYS_SHORT = ['S', 'M', 'T', 'W', 'T', 'F', 'S'];
export const MONTHS = ['January', 'February', 'March', 'April', 'May', 'June',
  'July', 'August', 'September', 'October', 'November', 'December'];
export const DAY_NAMES = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

export const startOfDay = (d) => { const x = new Date(d); x.setHours(0, 0, 0, 0); return x; };
export const endOfDay = (d) => { const x = new Date(d); x.setHours(23, 59, 59, 999); return x; };
export const startOfWeekMon = (d) => {
  const x = startOfDay(d);
  const dow = x.getDay();               // 0=Sun..6=Sat
  const diff = (dow + 6) % 7;           // 0=Mon..6=Sun
  x.setDate(x.getDate() - diff);
  return x;
};
export const addDays = (d, n) => { const x = new Date(d); x.setDate(x.getDate() + n); return x; };

export const fmtMoney = (n) => `£${Number(n || 0).toFixed(0)}`;
export const fmtTime = (iso) => {
  const d = new Date(iso);
  return `${String(d.getHours()).padStart(2, '0')}:${String(d.getMinutes()).padStart(2, '0')}`;
};
export const greeting = (h) => (h < 12 ? 'Good morning' : h < 18 ? 'Good afternoon' : 'Good evening');

/** Outstanding £ still owing on a single booking — mirrors Diary.js. */
export const owingFor = (b) => {
  if (b.paid_in_full) return 0;
  const price = Number(b.service?.price ?? 0);
  const deposit = Number(b.deposit_amount ?? 0);
  return Math.max(0, price - (b.deposit_paid ? deposit : 0));
};

/** Cash-vs-card chip shown on every Today's chair row. */
export const chipFor = (b) => {
  if (b.paid_in_full) {
    const m = b.balance_paid_method;
    return { cls: 'paid', label: m ? `Paid · ${m === 'cash' ? 'Cash' : 'Card'}` : 'Paid' };
  }
  if (b.deposit_paid) {
    const owe = owingFor(b);
    return { cls: 'partial', label: owe > 0 ? `£${owe.toFixed(0)} owing` : 'Deposit paid' };
  }
  if (Number(b.deposit_amount ?? 0) === 0 || b.service?.deposit_mode === 'none') {
    return { cls: 'notreq', label: 'Pay at chair' };
  }
  return { cls: 'unpaid', label: 'Not paid' };
};
